<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{ status: number }>();

const computedStatus = computed(() => {
    switch (props.status) {
        case 1:
            return "Te koop";
            break;
        case 2:
            return "Te huur";
            break;
        case 3:
            return "Verkocht";
            break;
        case 3:
            return "Verhuurd";
            break;
    }
    return "";
});
</script>

<template>
    {{ computedStatus }}
</template>
